import { classNames } from '../UNSAFE_classNames';
import { mergeDeepWithKey } from 'ramda';

type Obj = Record<string, unknown>;
type Interpolation<P> = (props: P) => Record<string, string> | object;

const combineClassNames = (key: string, l: any, r: any) =>
  key === 'class' ? classNames([l, r]) : r;

const mergeInterpolations =
  <P extends Obj>(interpolations: Interpolation<P>[]) =>
  (props: P) =>
    interpolations.reduce(
      (acc, fn) => mergeDeepWithKey(combineClassNames, acc, fn(props)),
      {} as Record<string, string>
    );

export { mergeInterpolations };
